//#region import
import React, { useEffect, useState } from 'react'
import { Avatar, Divider, Grid, IconButton, Popover, Tooltip, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { FnAxios, FnDialog, I18n } from 'utilities/utilities';
import DataGrid, { PaginationInterface, initRows } from 'components/DataGrid';
import { BtnAddOnTable, BtnEditOnTable, BtnViewOnTable } from 'components/Button/ButtonTable';
import { GetMenuPermission } from 'utilities/SystemFunction';
import InfoIcon from '@mui/icons-material/Info';
import PDFIcon from "../../../../src/assets/images/DocTypeIcon/PDF.svg";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { Circle } from '@mui/icons-material';
import DialogPreview from 'components/DialogPreview/DialogPreview';
import { FormProvider, useForm } from 'react-hook-form';
import { DatePickerItem } from 'components/Input/DatePicker/DatePickerItem';
import { BtnClear, BtnSearch } from 'components/Button/ButtonAll';
import { TextBoxItem } from 'components/Input/TextBox';
import { SelectItem } from 'components/Input/Select/SelectItem';
import { MultipleSelectItem } from 'components/Input/Select/MultipleSelectItem';
//#endregion

const MaterialInventoryTabel = ({ sMode }) => {
    const navigate = useNavigate();

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const [loadingTable, setLoadingTable] = useState(false);
    const [sUpdateName, setUpdateName] = useState(null);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [arrMaterialType, setMaterialType] = useState<any>([]);
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
    });
    const [isOpenFile, setIsOpenFile] = useState(false);
    const [arrModalFile, setArrModalFile] = useState([]);
    const [isPermission, setPermission] = useState<boolean>(false); // Permission


    useEffect(() => {
        GetMenuPermission(AxiosFn, setPermission, DialogFn);
    }, []);

    const currentDate = new Date(); // Get the current date
    const _dStart = new Date(currentDate.getFullYear(), 0, 1); //01/01/New
    const _dEnd = new Date(currentDate.getFullYear(), 12, 0); //31/12/New
    const form = useForm({
        shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            sDocumentNo: null,
            nReceiverUnitType: null,
            dStartDate: null,
            dEndDate: null,
        } as any,
    });
   
    const getTableMaterial = (p: PaginationInterface) => {
        setLoadingTable(true);
        let ObjForm = form.getValues();
        let nStart = ObjForm.dStartDate ? ObjForm.dStartDate.valueOf() : null;
        let nEnd = ObjForm.dEndDate ? ObjForm.dEndDate.valueOf() : null;

        let Param = {
            ...p,
            nDataWithdrawType: sMode == "Withdraw" ? 1 : 2,
            nStart: nStart,
            nEnd: nEnd,
            lstReceiverUnitType: ObjForm.nReceiverUnitType ? ObjForm.nReceiverUnitType : [],
            sDocumentNo: ObjForm.sDocumentNo
        };
        if (sMode == "Receive") {
            AxiosFn.Post(`MaterialInventory/GetTableReceiveMaterial`, Param, (result) => {
                setLoadingTable(false);
                setMaterialType(result.lstReceiveType);
                setDataRow({
                    ...p,
                    arrRows: [...result.lstDataReceiveMaterial],
                    nDataLength: result.ObjTable?.nDataLength,
                    nPageIndex: result.ObjTable?.nPageIndex,
                });
            });
        } else if (sMode == "Withdraw" || sMode == "WithdrawType2") {
            AxiosFn.Post(`MaterialInventory/GetTablWithdrawMaterial`, Param, (result) => {
                setLoadingTable(false);
                setMaterialType(result.lstReceiverUnitType);
                setDataRow({
                    ...p,
                    arrRows: [...result.lstDataWithdraw],
                    nDataLength: result.ObjTable?.nDataLength,
                    nPageIndex: result.ObjTable?.nPageIndex,

                });
            });
        }
        else if (sMode == "Return") {
            AxiosFn.Post(`MaterialInventory/GetTabReturnMaterial`, Param, (result) => {
                setLoadingTable(false);
                setMaterialType(result.lstReceiverUnitType);
                setDataRow({
                    ...p,
                    arrRows: [...result.lstDataReturn],
                    nDataLength: result.ObjTable?.nDataLength,
                    nPageIndex: result.ObjTable?.nPageIndex,

                });
            });
        }
    };

    const onClear = () => {
        form.reset();
        getTableMaterial(dataRow);
      
    }

    {/*Pop UpdateName*/ }
    const handleViewInfo = (e) => {
        setUpdateName(e.sUpdateName);
    }
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    {/*Receive File */ }
    const open = Boolean(anchorEl);

    const handleViewFile = (objRow) => {
        let objParam = { sID: objRow.sID };
        AxiosFn.Post(`MaterialInventory/OnViewFile`, objParam, (result) => {
            DialogFn.UnBlockUI();
            setArrModalFile(result.lstViewFile);
            console.log(result.lstViewFile);
            setIsOpenFile(true);
        });
    };
    const handleOpenFile = (e) => {
        let sUrl = e;
        window.open(sUrl, "_blank", "noreferrer");
    };

    {/*Table Receive */ }
    const dataColumn: any = [
        {
            renderHeader: (item) => (
                <>
                    <BtnAddOnTable
                        IsDisabled={!isPermission}
                        onClick={() => navigate("/MaterialReceiveForm?sMode=" + sMode)}
                        id={"Add"} />
                </>
            ),
            field: "ปุ่ม (เพิ่ม/แก้ไข)",
            align: "center",
            type: "actions",
            resizable: false,
            sortable: false,
            width: 60,
            getActions: (item) => {
                if (!isPermission) {
                    return [
                        <BtnViewOnTable
                            id="btnView"
                            key={item.row.sID}
                            onClick={() => goToEditReceive(item.row.sID)}
                        />
                    ];
                } else {
                    return [
                        <BtnEditOnTable
                            key={item.row.sID}
                            id="btnEdit"
                            onClick={() => goToEditReceive(item.row.sID)}
                        />
                    ];
                }
            },
        },
        {
            field: "sReceive",
            headerName: "วันที่รับพัสดุ",
            headerAlign: "center",
            align: "Left",
            sortable: true,
            flex: 1,
            width: 220,
        },
        {
            field: "sReceiveType",
            headerName: "ประเภทการรับวัสดุ",
            headerAlign: "center",
            align: "Left",
            sortable: true,
            flex: 2,
            width: 300,
        },
        {
            field: "sOrder",
            headerName: "เลขที่ใบสั่งซื้อ",
            headerAlign: "center",
            align: "center",
            sortable: true,
            flex: 2,
            width: 150,
        },
        {
            field: "objFile",
            headerName: `${I18n.SetText("PublishDoc.sFile")}`,
            headerAlign: "center",
            align: "center",
            sortable: true,
            minWidth: 120,
            renderCell: (item) => (
                <Tooltip title={`${I18n.SetText("PublishDoc.sDetail")}`}>
                    <IconButton size="small" onClick={() => handleViewFile(item.row)}>
                        <InsertDriveFileIcon
                            style={{ color: "#6e130d", cursor: "pointer" }}
                        />
                    </IconButton>
                </Tooltip>
            ),
        },

        {
            field: "sMaterialTotal",
            headerName: "จำนวนพัสดุ",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 150,
        },

        {
            field: "sUpdate",
            headerName: "วันที่แก้ไขล่าสุด",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 200,
            renderCell: (item) => {
                return (
                    <>
                        <Grid sx={{ mr: "4px" }}>
                            {item.row.sUpdate}
                        </Grid>
                        <IconButton size="small"
                            onClick={(e) => { handleClick(e); handleViewInfo(item.row); }}
                        >
                            <InfoIcon
                                style={{ color: "#6e130d", cursor: "pointer" }}
                            />
                        </IconButton>
                    </>
                )
            }
        },
    ];

    const goToEditReceive = (sID: string) => {
        navigate(`/MaterialReceiveForm?sMode=${sMode}&sID=${encodeURI(sID)}`);
    };

    const onDeleteReceive = (e) => {
        DialogFn.Submit("คุณต้องการลบข้อมูลใช่หรือไม่ ?", () => {
            AxiosFn.Post(`MaterialInventory/RemoveDataTable`, { lstID: e }, (result) => {
                if (result.nStatusCode === 200) {
                    DialogFn.Success("ลบสำเร็จ", () => {
                        getTableMaterial(dataRow);
                    });
                }
            });
        });
    }

    {/*Table Withdraw */ }
    const dataColumnWithdraw: any = [
        {
            renderHeader: (item) => (
                <>
                    <BtnAddOnTable
                        IsDisabled={!isPermission}
                        onClick={() => navigate(sMode == "Withdraw" ? "/MaterialWithdrawForm?sMode=" + sMode : "/MaterialWithdrawBorrowForm?sMode=" + sMode)}
                        id={"Add"} />
                </>
            ),
            field: "ปุ่ม (เพิ่ม/แก้ไข)",
            align: "center",
            type: "actions",
            resizable: false,
            sortable: false,
            width: 60,
            getActions: (item) => {
                if (!isPermission) {
                    return [
                        <BtnViewOnTable
                            id="btnView"
                            key={item.row.sID}
                            onClick={() => goToEdit(item.row.sID)}
                        />
                    ];
                } else {
                    return [
                        <BtnEditOnTable
                            key={item.row.sID}
                            id="btnEdit"
                            onClick={() => goToEdit(item.row.sID)}
                        />
                    ];
                }
            },
        },
        {
            field: "sWithdraw",
            headerName: sMode == "Withdraw" ? `${I18n.SetText("Material.sWithdrawDate")}` : sMode == "WithdrawType2" ? `${I18n.SetText("Material.sDocOrderAndNameType2")}` : `${I18n.SetText("Material.sReturnDate")}`,
            headerAlign: "center",
            align: "Left",
            sortable: true,
            width: 120,
        },
        {
            field: "sDocumentNo",
            headerName: sMode == "Withdraw" ? "เลขที่ใบเบิก" : sMode == "WithdrawType2" ? "เลขที่ใบขอยืม" : "เลขที่ใบขอคืน",
            headerAlign: "center",
            align: "Left",
            sortable: true,
            width: 150,

        },
        {
            field: "sNameWithdraw",
            headerName: sMode == "Withdraw" ? "ผู้ขอเบิก" : "ผู้ยืม",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 250,
            flex: 1,
        },
        {
            field: "sNameCreate",
            headerName: sMode == "Withdraw" ? "ผู้ทำรายการเบิก" : "ผู้ทำรายการยืม",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 250,
            flex: 1,
        },

        {
            field: "sMaterialTotal",
            headerName: sMode == "Withdraw" ? "จำนวนขอเบิก" : "จำนวนที่ขอยืม",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 150,
        },

        {
            field: "sUpdate",
            headerName: "วันที่แก้ไขล่าสุด",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 200,
            renderCell: (item) => {
                return (
                    <>
                        <Grid sx={{ mr: "4px" }}>
                            {item.row.sUpdate}
                        </Grid>
                        <IconButton size="small"
                            onClick={(e) => { handleClick(e); handleViewInfo(item.row); }}
                        >
                            <InfoIcon
                                style={{ color: "#6e130d", cursor: "pointer" }}
                            />
                        </IconButton>
                    </>
                )
            }
        },
    ];

    {/*Edit Withdraw */ }
    const goToEdit = (sID: string) => {
        navigate(sMode == "Withdraw" ? `/MaterialWithdrawForm?sMode=${sMode}&sID=${encodeURI(sID)}` : `/MaterialWithdrawBorrowForm?sMode=${sMode}&sID=${encodeURI(sID)}`);
    };

    {/*DeleteTable Withdraw */ }
    const onDeleteWithdraw = (e) => {
        DialogFn.Submit("คุณต้องการลบข้อมูลใช่หรือไม่ ?", () => {
            AxiosFn.Post(`MaterialInventory/RemoveDataTableWithdraw`, { lstID: e }, (result) => {
                if (result.nStatusCode === 200) {
                    DialogFn.Success("ลบสำเร็จ", () => {
                        getTableMaterial(dataRow);
                    });
                }
            });
        });
    }

    {/*Edit Return */ }
    const goToEditReturn = (sID: string) => {
        navigate(`/MaterialReturnForm?sMode=${sMode}&sID=${encodeURI(sID)}`);
    };

    {/*DeleteTable Return */ }
    const onDeleteReturn = (e) => {
        DialogFn.Submit("คุณต้องการลบข้อมูลใช่หรือไม่ ?", () => {
            AxiosFn.Post(`MaterialInventory/RemoveDataTableReturn`, { lstID: e }, (result) => {
                if (result.nStatusCode === 200) {
                    DialogFn.Success("ลบสำเร็จ", () => {
                        getTableMaterial(dataRow);
                    });
                }
            });
        });
    }

    {/*Table Return */ }
    const dataColumnReturn: any = [
        {
            renderHeader: (item) => (
                <>
                    <BtnAddOnTable
                        IsDisabled={!isPermission}
                        onClick={() => navigate("/MaterialReturnForm?sMode=" + sMode)}
                        id={"Add"} />
                </>
            ),
            field: "ปุ่ม (เพิ่ม/แก้ไข)",
            align: "center",
            type: "actions",
            resizable: false,
            sortable: false,
            width: 60,
            getActions: (item) => {
                if (!isPermission) {
                    return [
                        <BtnViewOnTable
                            id="btnView"
                            key={item.row.sID}
                            onClick={() => goToEditReturn(item.row.sID)}
                        />
                    ];
                } else {
                    return [
                        <BtnEditOnTable
                            key={item.row.sID}
                            id="btnEdit"
                            onClick={() => goToEditReturn(item.row.sID)}
                        />
                    ];
                }
            },
        },
        {
            field: "sReturn",
            headerName: `${I18n.SetText("Material.sReturnDate")}`,
            headerAlign: "center",
            align: "Left",
            sortable: true,
            width: 120,
        },
        {
            field: "sDocumentNo",
            headerName: "เลขที่ใบขอคืน",
            headerAlign: "center",
            align: "Left",
            sortable: true,
            width: 150,

        },
        {
            field: "sNameReturn",
            headerName: "ผู้คืน",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 250,
        },
        {
            field: "sNameCreate",
            headerName: "ผู้ทำรายการคืน",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 250,
        },

        {
            field: "sMaterialTotal",
            headerName: "จำนวนรายการที่คืน",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 150,
        },
        {
            field: "sMaterialTotalff",
            headerName: "จำนวนรายการคงค้าง",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 150,
        },

        {
            field: "sUpdate",
            headerName: "วันที่แก้ไขล่าสุด",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 200,
            renderCell: (item) => {
                return (
                    <>
                        <Grid sx={{ mr: "4px" }}>
                            {item.row.sUpdate}
                        </Grid>
                        <IconButton size="small"
                            onClick={(e) => { handleClick(e); handleViewInfo(item.row); }}
                        >
                            <InfoIcon
                                style={{ color: "#6e130d", cursor: "pointer" }}
                            />
                        </IconButton>
                    </>
                )
            }
        },
    ];



    useEffect(() => {
        getTableMaterial(dataRow);
       // gettest();
    }, []);


    return (
        <React.Fragment>
            <Grid item xs={12} md={12} container spacing={2} justifyItems={'flex-start'} justifyContent={'end'}>
                <FormProvider {...form}>
                    <Grid item xs={12} md={4}>
                        <TextBoxItem
                            required={false}
                            label={sMode == "Withdraw" ? `${I18n.SetText("Material.sDocOrderAndName")}` : sMode == "WithdrawType2" ? `${I18n.SetText("Material.sDocOrderAndNameType2")}` : `${I18n.SetText("Material.sOrderNo")}`}
                            id={'sDocumentNo'}
                            name={'sDocumentNo'}
                            maxLength={250}
                            type={'text'}
                            IsShowMessageError
                            disabled={!isPermission}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <DatePickerItem
                            name={"dStartDate"}
                            id={"dStartDate"}
                            label={`${I18n.SetText("Leave.sStartDate")}`}
                            fullWidth={true}
                            required={false}
                            disabled={false}
                            maxDate={form.watch("dEndDate")}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <DatePickerItem
                            name={"dEndDate"}
                            id={"dEndDate"}
                            label={`${I18n.SetText("Leave.sEndDate")}`}
                            fullWidth={true}
                            required={false}
                            disabled={false}
                            minDate={form.watch("dStartDate")}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <MultipleSelectItem
                            id={'nReceiverUnitType'}
                            name={'nReceiverUnitType'}
                            label={sMode == "Withdraw" ? `${I18n.SetText("Material.sTypeWithdraw")}` : sMode == "WithdrawType2" ? `${I18n.SetText("Material.sTypeWithdrawType2")}` : sMode == "Return" ? "ผู้ขอคืน" : `${I18n.SetText("Material.sSelectMaterialtype")}`}
                            placeholder={sMode == "Withdraw" ? `${I18n.SetText("Material.sTypeWithdraw")}` : sMode == "WithdrawType2" ? `${I18n.SetText("Material.sTypeWithdrawType2")}` : sMode == "Return" ? "ผู้ขอคืน" : `${I18n.SetText("Material.sSelectMaterialtype")}`}
                            options={arrMaterialType || []}
                            required={false}
                            disabled={!isPermission}
                            limitTag={1}
                        />
                    </Grid>
                    <Grid item xs={12} md={1} container spacing={1} justifyItems={'flex-start'} justifyContent={'end'}>
                        <Grid item>
                            <BtnClear id={'btnClearSearchAll'} IsCircleWithOutText={true} onClick={() => { onClear(); }} />
                        </Grid>
                        <Grid item>
                            <BtnSearch id={'btnSearchAll'} IsCircleWithOutText={true} onClick={() => { getTableMaterial(dataRow); }} />
                        </Grid>
                    </Grid>
                </FormProvider>
            </Grid>
            <Grid item xs={12} sx={{ mt: 1 }}>
                <DataGrid
                    sTableID='tb1'
                    columns={sMode == "Receive" ? dataColumn : sMode == "Return" ? dataColumnReturn : dataColumnWithdraw}
                    rows={dataRow}
                    isHiddenToolHead={true}
                    onLoadData={getTableMaterial}
                    isLoading={loadingTable}
                    isShowCheckBox={isPermission}
                    onRowSelectable={(p) => !p.row.isDelete}
                    onDelete={sMode == "Receive" ? onDeleteReceive : sMode == "Return" ? onDeleteReturn : onDeleteWithdraw}
                />
            </Grid>

            {/*PopUp Receive File */}
            <DialogPreview
                IsOpen={isOpenFile}
                Title={`${I18n.SetText("PublishDoc.sFile")}`}
                required={true}
                onClose={() => setIsOpenFile(false)}
                sMaxWidth="sm"
                CloseSave={true}
            >
                {arrModalFile.map(m => {
                    let sFileType = m.sFileName.split(".")[m.sFileName.split(".").length - 1].toLowerCase();
                    let sUrl = m.sFileLink;
                    return (
                        <Grid container key={m.sFileName} justifyContent={"space-between"} xs={12} md={12} spacing={1}>
                            <Grid item sx={{ marginTop: 2 }}>
                                <div onClick={() => handleOpenFile(m.sFileLink)} style={{ cursor: "pointer", color: "blue", marginTop: 1 }}>
                                    <Circle
                                        sx={{
                                            color: "blue",
                                            height: "7px",
                                            marginLeft: 1,
                                        }}
                                    />
                                    {m.sFileName}
                                </div>
                            </Grid >
                            <Grid item sx={{ marginTop: 1 }}>
                                {sFileType === "jpg" || sFileType === "jpeg" || sFileType === "png" && (
                                    <Grid item md={12} xs={12}>
                                        <Tooltip title={`${I18n.SetText("PublishDoc.sShowFile")}`}>
                                            <Avatar
                                                alt=""
                                                src={sUrl}
                                                sx={{ width: 40, height: 40, cursor: "pointer" }}
                                                onClick={() => handleOpenFile(m.sFileLink)}
                                            />
                                        </Tooltip>
                                    </Grid>
                                )}
                                {sFileType === "pdf" && (
                                    <Grid item md={12} xs={12}>
                                        <Tooltip title={`${I18n.SetText("PublishDoc.sShowFile")}`}>
                                            <img
                                                style={{ width: 30, height: 30, cursor: "pointer", marginBottom: 1 }}
                                                src={PDFIcon}
                                                alt=""
                                                onClick={() => handleOpenFile(m.sFileLink)}
                                            />
                                        </Tooltip>
                                    </Grid>
                                )}
                            </Grid>
                            <Grid item xs={12}>
                                <Divider />
                            </Grid>
                        </Grid>
                    );
                })
                }
            </DialogPreview>

            {/* pop over UserUpdate */}
            <Popover
                id={`sUpdateName`}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <Typography sx={{ p: 2 }}>{sUpdateName}</Typography>
            </Popover>
        </React.Fragment >
    )
}
export default MaterialInventoryTabel;

